<template>
  <div class="contentCenter-footer">
    JDH健康内容开放平台 Copyright @ 2020-2021
  </div>
</template>

<script>
  export default {
    name: "footer",
    data(){

    }
  }
</script>

<style lang="scss" scoped>
  .contentCenter-footer{
    position: absolute;
    line-height: 14px;
    font-size: 14px;
    color: rgba(202,204,208,1);
    bottom: 18px;
    right: 569px;
  }
</style>
